import { render, staticRenderFns } from "./Presentacion.vue?vue&type=template&id=886bde9c&scoped=true&"
import script from "./Presentacion.vue?vue&type=script&lang=js&"
export * from "./Presentacion.vue?vue&type=script&lang=js&"
import style0 from "./Presentacion.vue?vue&type=style&index=0&id=886bde9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886bde9c",
  null
  
)

export default component.exports